import { FormikHelpers } from 'formik';
import { handleError, post, put } from './ajax';
import Toast from './Toast';

export interface ISubmission {
  url: string;
  values: any;
  isNew: boolean;
  actions: FormikHelpers<any>;
  onAjaxComplete?: (data: any) => any;
  onError?: () => void;
}

export function handleSubmission(submission: ISubmission) {
  const { isNew, actions, values, onAjaxComplete, onError, url } = submission;
  if (isNew) {
    post(
      url,
      values,
      (data) => {
        Toast.info('Operation successful');
        actions.resetForm();
        onAjaxComplete && onAjaxComplete(data);
      },
      (err, resp) => {
        handleError(err, resp);
        onError && onError();
      },
      () => {
        actions.setSubmitting(false);
      },
    );
  } else {
    put(
      url,
      values,
      (data) => {
        Toast.info('Update successful');
        actions.resetForm();
        onAjaxComplete && onAjaxComplete(data);
      },
      (err, resp) => {
        handleError(err, resp);
        onError && onError();
      },
      () => {
        actions.setSubmitting(false);
      },
    );
  }
}
